var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.title,
        width: _vm.width,
        "modal-append-to-body": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _vm.$slots.header
        ? [_vm._t("header")]
        : _c("div", [_c("h3", [_vm._v(_vm._s(_vm.title))])]),
      _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
      _vm.$slots.footer
        ? _c("div", { staticClass: "footer" }, [_vm._t("footer")], 2)
        : _c("div", { staticClass: "footer" }, [
            _c(
              "div",
              { staticClass: "footer-buttons" },
              [
                _vm.showCancelButton
                  ? _c(
                      "el-button",
                      {
                        class: _vm.cancelButtonClass,
                        attrs: {
                          size: _vm.cancelButtonSize,
                          type: _vm.cancelButtonType,
                        },
                        on: { click: _vm.handleCancel },
                      },
                      [_vm._v(_vm._s(_vm.cancelButtonText))]
                    )
                  : _vm._e(),
                _vm.showConfirmButton
                  ? _c(
                      "el-button",
                      {
                        class: _vm.confirmButtonClass,
                        attrs: {
                          size: _vm.confirmButtonSize,
                          type: _vm.confirmButtonType,
                        },
                        on: { click: _vm.handleConfirm },
                      },
                      [_vm._v(_vm._s(_vm.confirmButtonText))]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }